import { NgModule } from '@angular/core';
import { DataTableModule } from 'angular2-datatable';
import { SharedComponentsModule } from '../../../../shared-components/shared-components.module';
import { CommonModule } from '@angular/common';
import { VendorContactRoutingModule } from './vendor-contact-routing.module';
import { VendorContactComponent } from './vendor-contact.component';
import { UpdateContactComponent } from './update-contact/update-contact.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    SharedComponentsModule,
    DataTableModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    VendorContactRoutingModule
  ],
  declarations: [VendorContactComponent, UpdateContactComponent]
})
export class VendorContactModule { }



// WEBPACK FOOTER //
// ./src/app/pages/vendor/my-vendor/vendor-contact/vendor-contact.module.ts